import { UserId } from "src/app/interfaces";

export interface Substitute {
  userId: UserId;
  deputyId: UserId;
  startDate: Date;
  endDate: Date;
}

export interface SubstituteResponse {
  userId: UserId;
  deputyId: UserId;
  startDate: string;
  endDate: string;
}

export function convert(res: SubstituteResponse): Substitute {
  if (!res) {
    return null;
  }
  return {
    ...res,
    startDate: res.startDate ? new Date(res.startDate) : null,
    endDate: res.endDate ? new Date(res.endDate) : null
  };
}
